import { CounterData } from '@/api/models/counters/lib/counters.types'
import { getMskNow, isDayInInterval, toMskDay } from '@/utils/datetime'

const canEditCounter = (counter: CounterData) =>
  !counter.readOnly &&
  isDayInInterval(
    getMskNow(),
    toMskDay(counter.startDate),
    toMskDay(counter.endDate)
  )

export { canEditCounter }
